import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class FilterService {
    constructor() {}

    setFilter(key: string, filter: any): void {
        try {
            const value = JSON.stringify(filter);
            localStorage.setItem(key, value);
        } catch (e) {
            console.error(`Erro ao salvar filtro ${key}:`, e);
        }
    }

    getFilter<T = any>(key: string): T | null {
        try {
            const value = localStorage.getItem(key);
            return value ? JSON.parse(value) as T : null;
        } catch (e) {
            console.error(`Erro ao recuperar filtro ${key}:`, e);
            return null;
        }
    }

    clearFilter(key: string): void {
        localStorage.removeItem(key);
    }
}
